const { configObj } = require('./' + (process.env.NODE_ENV || 'development') + '.env')

const config = { ...configObj }

export default config
